<template>
    <section class="page-content">
        <RoomTopComponent/>
        <RoomBoxComponent/>
        <!-- <RoomExperienceComponent/> -->
    </section>
</template>

<script setup>
    import RoomTopComponent from '../components/room/RoomTopComponent.vue';
    import RoomBoxComponent from '@/components/room/RoomBoxComponent.vue';
    // import RoomExperienceComponent from '@/components/room/RoomExperienceComponent.vue';
    window.scrollTo(0, 0);
</script>

<style scoped>
    /*  */
</style>